import Selector from '../../Components/Select/Select'
import React, { useState, useEffect, KeyboardEvent } from 'react'
import Input from './../../Components/Select/Input'
import http from './../../Service/http'
import { direction } from './../../store/direction'
import { SelectType } from '../../store/models'
import { useTranslation } from 'react-i18next'
import { BsSearch } from 'react-icons/bs'

function AdditionAcadem({ setPage }: { setPage: (num: number) => void }) {
	const [sdd, setSDD] = useState<SelectType>({
		value: 1,
		label: 'Напрвления'
	})
	const { t } = useTranslation()
	const [text, setText] = useState<string>('')

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
			<Selector
				options={[
					{
						label: 'Напраления',
						value: 1
					},
					{
						label: 'Специальности',
						value: 2
					},
					{
						label: 'Дисциплины',
						value: 3
					}
				]}
				value={sdd}
				placeholder={'Выберите'}
				onChange={async (state: SelectType) => {
					await direction.setSDD(state.value)
					if (state.value === 1) {
						const res = await http.get('/addition/direction?search_direction=' + '' + '&pageNum=' + 1)
						direction.newAcadem(res.data.DirectionList)
						setPage(1)
					} else if (state.value === 2) {
						const res = await http.get('/addition/special?search_direction=' + '' + '&pageNum=' + 1)
						direction.newAcadem(res.data.SpecialList)
						setPage(1)
					} else if (state.value === 3) {
						const res = await http.get('/addition/discipline?search_direction=' + '' + '&pageNum=' + 1)
						direction.newAcadem(res.data.DisciplineList)
						setPage(1)
					}
					setSDD(state)
					setText('')
				}}
				isSearchable={false}
				isDisabled={false}
				isClearable={false}
				title={'Выберите'}
				name=''
				withBorder={true}
			/>
			<Input
				style={{ width: '400px', zIndex: '1' }}
				placeholder={t('st:placeHolder.byName')}
				value={text}
				oninput={setText}
				keyDown={async (e: KeyboardEvent<HTMLInputElement>) => {
					if (e.key === 'Enter') {
						if (sdd.value === 1) {
							const res = await http.get('/addition/direction?search_direction=' + text + '&pageNum=' + 1)
							direction.newAcadem(res.data.DirectionList)
							direction.setSddText(text)
						} else if (sdd.value === 2) {
							const res = await http.get('/addition/special?search_special=' + text + '&pageNum=' + 1)
							direction.newAcadem(res.data.SpecialList)
							direction.setSddText(text)
						} else if (sdd.value === 3) {
							const res = await http.get('/addition/discipline?search_discipline=' + text + '&pageNum=' + 1)
							direction.newAcadem(res.data.DisciplineList)
							direction.setSddText(text)
						}
					}
				}}
			/>
			<BsSearch
				className='search_icon'
				onClick={async () => {
					if (sdd.value === 1) {
						const res = await http.get('/addition/direction?search_direction=' + text + '&pageNum=' + 1)
						direction.newAcadem(res.data.DirectionList)
						direction.setSddText(text)
					} else if (sdd.value === 2) {
						const res = await http.get('/addition/special?search_special=' + text + '&pageNum=' + 1)
						direction.newAcadem(res.data.SpecialList)
						direction.setSddText(text)
					} else if (sdd.value === 3) {
						const res = await http.get('/addition/discipline?search_discipline=' + text + '&pageNum=' + 1)
						direction.newAcadem(res.data.DisciplineList)
						direction.setSddText(text)
					}
				}}
			/>
		</div>
	)
}

export default AdditionAcadem
